/** P10 (ADR-0018) — estado mínimo da identificação voluntária que a regra lê. */
export interface IdentidadeFormState {
  readonly identificacaoVoluntaria: boolean;
  readonly nome: string;
  readonly contato: string;
}

/**
 * P10 — a identificação foi iniciada mas está incompleta?
 *
 * Regra ÚNICA, lida por DOIS consumidores que precisam concordar sempre:
 *   1. `IntakeWizard` — decide o `disabled` do botão Enviar.
 *   2. `Step4Revisao` — decide se exibe o motivo do bloqueio na tela.
 *
 * Estavam fadados a divergir se cada um reimplementasse o `trim() === ''`: o
 * botão apagaria por um critério e o aviso apareceria por outro, produzindo de
 * novo o botão morto sem explicação que este trabalho existe para matar.
 *
 * CPF é deliberadamente AUSENTE do tipo. É campo opcional; travar o envio por
 * causa dele seria atrito sem ganho (decisão do operador, 29/07). Deixá-lo fora
 * da assinatura faz com que "CPF passa a bloquear" exija mudar o contrato — uma
 * decisão visível em code review, não um `&&` que alguém acrescenta de passagem.
 */
export function identidadeIncompleta(state: IdentidadeFormState): boolean {
  if (!state.identificacaoVoluntaria) return false;
  return state.nome.trim() === '' || state.contato.trim() === '';
}
